export default "__VITE_ASSET__CEo751SF__"